"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAccount = void 0;
const react_1 = __importStar(require("react"));
const LocalAccount_1 = __importDefault(require("LocalAccount"));
// This is a higher order component that, when wrapped
// around a component, it will automatically re-render the
// component anytime the accountId has changed. It also passes
// the current accountId as a prop in case a component
// needs to access it directly.
const withAccount = (Component) => {
    const WrappedWithAccount = (props) => {
        const [, reRender] = (0, react_1.useState)({});
        (0, react_1.useEffect)(() => {
            LocalAccount_1.default.registerOnChange(() => reRender({}));
        }, []);
        return (react_1.default.createElement(Component, Object.assign({}, props, { account: LocalAccount_1.default.get(), accountId: LocalAccount_1.default.getId() })));
    };
    return WrappedWithAccount;
};
exports.withAccount = withAccount;
